import config from '../config';

class DataQualityService {
  /**
   * Fetch request data and field configuration for data quality updates
   * @param {number} requestId - The request ID to fetch
   * @returns {Promise<Object>} Request data with field configuration
   */
  static async getRequestDataQuality(requestId) {
    try {
      const response = await fetch(`${config.apiUrl}/api/data-quality/${requestId}`);
      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching request data quality:', error);
      throw error;
    }
  }

  /**
   * Update request with new field values
   * @param {number} requestId - The request ID to update
   * @param {Object} updateData - The update data containing circuit_fields and request_fields
   * @returns {Promise<Object>} Update result
   */
  static async updateRequestDataQuality(requestId, updateData) {
    try {
      const response = await fetch(`${config.apiUrl}/api/data-quality/${requestId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData),
      });

      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating request data quality:', error);
      throw error;
    }
  }

  /**
   * Get field configuration reference
   * @returns {Promise<Object>} Field configuration
   */
  static async getFieldConfiguration() {
    try {
      const response = await fetch(`${config.apiUrl}/api/data-quality/fields`);
      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching field configuration:', error);
      throw error;
    }
  }

  /**
   * Push request data to Excel
   * @param {number} requestId - The request ID to push to Excel
   * @returns {Promise<Object>} Push result
   */
  static async pushToExcel(requestId) {
    try {
      const response = await fetch(`${config.apiUrl}/api/data-quality/${requestId}/push-to-excel`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error pushing to Excel:', error);
      throw error;
    }
  }
}

export default DataQualityService;